import { Button, Form, Input, message, Modal} from 'antd';
import React, { useState } from 'react'
import { useNewsTypeAddMutation } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
function NewsTypeAdd() {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [info,setInfo] = useState({
         ent_content:'',
    });
    const [submitAdd] = useNewsTypeAddMutation()
    return (
        <>
            <Button type='primary' onClick={() => {setOpen(true)}}>新增</Button>
            <Modal
                open={open}
                title='新增新闻类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    submitAdd({
                        ent_name:info.ent_name,
                        ent_content:info.ent_content,
                        ent_e_id:localStorage.getItem('e_id'),
                        ent_uid:localStorage.getItem('eu_id'),
                        ent_uname:localStorage.getItem('eu_name'),
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('新增成功！')  
                            setOpen(false)
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                   
                >                            
                    <Form.Item name="name" label='名称' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,ent_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="content" label='备注' wrapperCol={{span:20}}>
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,ent_content:e}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default NewsTypeAdd